import { Modal, Button, Select, Radio, message } from "antd";
import { useState } from "react";
import { CALL_API, CALL_FEATCH_API } from "common/API";
import { useDispatch, useSelector } from "react-redux";
import { getallRoleList, getClientid, getRoleList } from "redux/selectors";
import {
  setDepartmentList,
  setLocationList,
  setRoleList,
  setUserList,
} from "redux/actions";
import styled from "styled-components";
const CustomRadioGroup = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .ant-radio-checked .ant-radio-inner {
    border-color: #0acf0a;      /* border of checked circle */
    background-color: #0acf0a;  /* fill of checked circle */
  }

  .ant-radio:hover .ant-radio-inner {
    border-color: green;      /* hover effect */
  }
  .ant-radio-wrapper.ant-radio-wrapper-checked .ant-radio-inner{
	border-color: #ffffff;
  }
  .ant-radio-wrapper .ant-radio-inner::after {
    background-color: #fff8f8 !important;
    border: 1px solid #ffffffff !important;
}
.ant-radio-wrapper.ant-radio-wrapper-checked .ant-radio-inner {
    border-color: #ffffff !important;
}

`;
export default function ChangeRoleModal({
  open,
  onClose,
  oldRoleId,
  userIds,
  customUserId,
  fetchEmployeeDetails,
  setParentLoading,
  roleData
}) {
  const [step, setStep] = useState(1);
  const [selectedRole, setSelectedRole] = useState(null);
  const [confirmChoice, setConfirmChoice] = useState("Yes");
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("default");

  const clientId = useSelector((state) => getClientid(state));
  const allRoleList = useSelector((state) => getallRoleList(state));
  const currentRoleIds = roleData?.roleid || [];

  const roleOptions = (allRoleList || [])
    .filter((role) =>
      role.display === 1 &&
      !currentRoleIds.includes(String(role.roleId)) // ❌ exclude current role
    )
    .map((role) => ({
      value: role.roleId,
      label: role.roleName,
    }));


  const dispatch = useDispatch();

  const fetchMasterData = async (
  ) => {
    const { code, userList } = await CALL_API(`master-data/${clientId}`, "post", {
      fetch_master_data: true,
    });

    if (code === "SUCCESS" && userList) {
      dispatch(setUserList(userList));
    }
  };
  const handleComplete = async () => {
    let userIdList = [];
    if (customUserId) {
      userIdList = [customUserId];
    } else if (Array.isArray(userIds)) {
      if (typeof userIds[0] === "object") {
        userIdList = userIds.map((u) => u.userid);
      } else {
        userIdList = userIds;
      }
    }
    try {
      setLoading(true);
      const payload = {
        role_id: selectedRole,
        oldRoleId: oldRoleId,
        userIds: userIdList,
        type: type
      };
      const response = await CALL_FEATCH_API(
        `change-role/${clientId}`,
        "post",
        payload
      );
      if (response && response.status === 200) {
        setParentLoading(true);
        onClose();
        await fetchMasterData();
        await fetchEmployeeDetails();
        message.success("Role changed successfully!");
        setStep(1);
        setSelectedRole(null);
        setConfirmChoice("Yes");
      } else {
        message.error(response?.message || "Failed to change role");
      }
    } catch (error) {
      console.error("Error changing role:", error);
      message.error("Error while changing role");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={step === 1 ? "Change Role" : "Permission Preference"}
      destroyOnClose
      centered
      bodyStyle={{ paddingTop: 0, borderRadius: 10 }}
      style={{ borderRadius: "10px" }}
      modalRender={(modal) => (
        <div style={{ borderRadius: 10, overflow: "hidden" }}>{modal}</div>
      )}
    >
      {step === 1 && (
        <>
          <p>Choose Role </p>
          <Select
            placeholder="Select"
            options={roleOptions}
            style={{ width: "100%" }}
            value={selectedRole}
            onChange={setSelectedRole}
          />
          <div style={{ textAlign: "right", marginTop: 70 }}>
            <Button onClick={onClose} style={{ marginRight: 8, borderRadius: 10, border: "1px solid #000000ff", width: 120 }}>
              Cancel
            </Button>
            <Button
              type="primary"
              disabled={!selectedRole}
              style={{ marginRight: 8, borderRadius: 10, border: "1px solid #000000ff", width: 120 }}
              onClick={() => setStep(2)}
            >
              Next
            </Button>
          </div>
        </>
      )}

      {step === 2 && (
        <>
          <CustomRadioGroup
            onChange={(e) => setType(e.target.value)}
            value={type}
          >
            <Radio value="retain">Retain employee’s current permission.</Radio>
            <Radio value="default">Apply the default permissions of the new role</Radio>
          </CustomRadioGroup>

          <div style={{ textAlign: "right", marginTop: 70 }}>
            <Button onClick={onClose} style={{ marginRight: 8, borderRadius: 10, border: "1px solid #000000ff", width: 120 }}>
              Cancel
            </Button>
            <Button
              type="primary"
              disabled={!confirmChoice}
              loading={loading}
              onClick={handleComplete}
              style={{ marginRight: 8, borderRadius: 10, border: "1px solid #000000ff", width: 120 }}

            >
              Complete
            </Button>
          </div>
        </>
      )}
    </Modal>
  );
}